import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMoveItem = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 9,
	viewBox: "0 0 12 9",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M1.5 3.75C0.675 3.75 -1.01629e-07 3.075 -6.55671e-08 2.25C-2.95052e-08 1.425 0.675 0.75 1.5 0.75C2.325 0.75 3 1.425 3 2.25C3 3.075 2.325 3.75 1.5 3.75ZM7.5 2.25C7.5 1.425 6.825 0.75 6 0.75C5.175 0.75 4.5 1.425 4.5 2.25C4.5 3.075 5.175 3.75 6 3.75C6.825 3.75 7.5 3.075 7.5 2.25ZM12 2.25C12 1.425 11.325 0.75 10.5 0.75C9.675 0.75 9 1.425 9 2.25C9 3.075 9.675 3.75 10.5 3.75C11.325 3.75 12 3.075 12 2.25ZM9 6.75C9 7.575 9.675 8.25 10.5 8.25C11.325 8.25 12 7.575 12 6.75C12 5.925 11.325 5.25 10.5 5.25C9.675 5.25 9 5.925 9 6.75ZM7.5 6.75C7.5 5.925 6.825 5.25 6 5.25C5.175 5.25 4.5 5.925 4.5 6.75C4.5 7.575 5.175 8.25 6 8.25C6.825 8.25 7.5 7.575 7.5 6.75ZM3 6.75C3 5.925 2.325 5.25 1.5 5.25C0.675 5.25 -2.26206e-07 5.925 -2.62268e-07 6.75C-2.9833e-07 7.575 0.675 8.25 1.5 8.25C2.325 8.25 3 7.575 3 6.75Z",
		fill: "black",
		fillOpacity: .12
	})]
});
const ForwardRef = forwardRef(SvgMoveItem);
export { ForwardRef as ReactComponent };
